// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_linhaTitulo__Ep5i\\+ {
  border-bottom: 0.1rem solid #0f2047 !important;
  margin-left: 40px !important;
  width: 80px !important;
  margin-top: -16px !important;
}

.styles_linhaTituloPopup__GMDP0 {
  border-bottom: 0.2rem solid #0f2047 !important;
  margin-left: 40px !important;
  width: 80px !important;
  margin-top: 0px !important;
  padding-top: 0px !important;
}

.styles_tituloContainer__Hk87K {
  display: flex !important;
  align-items: center !important;
  margin-left: 40px !important;
  margin-top: -28px !important;
}

.styles_titulo__FPngx {
  font-size: 44px !important;
  color: #0f2047 !important;
  font-family: "Abhaya Libre" !important;
}

.styles_iconeTitulo__89m6G {
  font-size: 40px !important;
  color: #0f2047 !important;
  margin-left: 12px !important;
  margin-right: 12px !important;
  margin-top: -8px !important;
}

.styles_iconeTituloPopup__bzjw1 {
  font-size: 40px !important;
  color: #0f2047 !important;
  margin-top: -8px !important;
}

.styles_botaoContainer__HRwMu {
  display: flex !important;
  align-items: center !important;
  margin-left: 40px !important;
}

.styles_botaoNovo__YUcyj {
  width: 120px !important;
  background-color: #0f2047 !important;
  color: #ffffff !important;
  border-color: #ffffff !important;
  border-width: 1px !important;
  border-style: solid !important;
  font-family: "Inter" !important;
  font-size: 16px !important;
  margin-top: 12px !important;
  margin-left: 20% !important;
  border-radius: 8px !important;
  transition: all 0.3s ease !important;
  text-transform: capitalize !important;
  height: 36px !important;
}

.styles_botaoNovo__YUcyj:hover {
  transform: scale(0.95) !important;
}

.styles_tituloPopup__tEAnc {
  font-size: 28px !important;
  color: #0f2047 !important;
  font-family: "Abhaya Libre" !important;
  margin: 8px;
}

.styles_tituloPopupContainer__qrOAD {
  display: flex !important;
  align-items: center !important;
}

.styles_botoesPopupGeral__Di-L\\+ {
  margin-bottom: 20px !important;
  margin-right: 20px !important;
}

.styles_botaoPopupSalvar__dgog1 {
  width: 180px !important;
  background-color: #0f2047 !important;
  color: #ffffff !important;
  border-color: #ffffff !important;
  border-width: 1px !important;
  border-style: solid !important;
  font-family: "Inter" !important;
  border-radius: 8px !important;
  transition: all 0.3s ease !important;
}

.styles_botaoPopupSalvar__dgog1:hover {
  transform: scale(0.95) !important;
}

.styles_botaoPopupCancelar__Ag8OR {
  width: 180px !important;
  background-color: #ffffff !important;
  color: #0f2047 !important;
  border-color: #0f2047 !important;
  border-width: 1px !important;
  border-style: solid !important;
  font-family: "Inter" !important;
  border-radius: 8px !important;
  transition: all 0.3s ease !important;
  font-weight: 600 !important;
}

.styles_botaoPopupCancelar__Ag8OR:hover {
  transform: scale(0.95) !important;
}

.styles_txtBuscaTabela__avyeN {
  margin-top: 16px !important;
  margin-left: 16px !important;
}

.styles_iconeBusca__9\\+5LH {
  color: #18316e !important;
  font-size: 28px !important;
  margin-top: 16px !important;
}

.styles_textoExclusao__WXc-\\+ {
  color: #000000 !important;
  font-family: "Inter" !important;
  font-size: 16px !important;
}

.styles_tituloExclusao__FLb2U {
  color: #0f2047 !important;
  font-family: "Abhaya Libre" !important;
  font-size: 44px !important;
}

.styles_botaoPopupExcluir__gq-Ks {
  width: 120px !important;
  background-color: #0f2047 !important;
  color: #ffffff !important;
  border-color: #ffffff !important;
  border-width: 1px !important;
  border-style: solid !important;
  font-family: "Inter" !important;
  border-radius: 8px !important;
  transition: all 0.3s ease !important;
  margin-right: 7%;
  margin-bottom: 4%;
}

.styles_botaoPopupExcluir__gq-Ks:hover {
  transform: scale(0.95) !important;
}

.styles_botaoPopupCancelarExclusao__\\+CTWp {
  width: 120px !important;
  background-color: #ffffff !important;
  color: #0f2047 !important;
  border-color: #0f2047 !important;
  border-width: 1px !important;
  border-style: solid !important;
  font-family: "Inter" !important;
  border-radius: 8px !important;
  transition: all 0.3s ease !important;
  font-weight: 600 !important;
  margin-right: 4%;
  margin-bottom: 4%;
}

.styles_botaoPopupCancelarExclusao__\\+CTWp:hover {
  transform: scale(0.95) !important;
}

/* Adicione este trecho de código ao seu arquivo de estilos CSS (por exemplo, styles.module.css) */

.styles_caixaTextoPequena__wun3g {
  height: 28px;
  /* Ajuste a altura conforme necessário */
}

.styles_caixaDeTexto__DvCZA {
  margin: 200px 70 !important;
  height: 30px !important;
}

.styles_botaoVoltar__MDMkx {
  background-color: #0f2047;
  color: #ffffff;
  border-color: #ffffff;
  border-width: 1px;
  border-style: solid;
  font-family: "Inter";
  border-radius: 8px;
  transition: all 0.3s ease;
  text-transform: capitalize;
  height: 36px;
}

.styles_botaoVoltar__MDMkx:hover {
  background-color: #ffffff;
  color: #0f2047;
}

.styles_inputPequeno__DA4uv {
  width: 100%;
  padding: 5px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  /* Adicione mais estilos conforme necessário */
}

.styles_botaoVoltar__MDMkx:hover {
  background-color: #0f2047;
  color: #ffffff;
}

.styles_labelPequeno__N98Rd {
  font-size: 12px;
  /* Ajuste o valor conforme necessário */
}

.styles_placeholder__9meIw {
  font-size: 12px;
  /* Ajuste o valor conforme necessário */
  /* Outros estilos do placeholder, se necessário */
}

.styles_popupHeader__zkWxz {
  margin-top: 8px;
  padding-bottom: 0px !important;
}

.styles_popupContent__Y-XBO {
  padding-top: 0px;
}`, "",{"version":3,"sources":["webpack://./src/pages/CondicaoComercial/styles.module.css"],"names":[],"mappings":"AAAA;EACE,8CAA8C;EAC9C,4BAA4B;EAC5B,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,8CAA8C;EAC9C,4BAA4B;EAC5B,sBAAsB;EACtB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,4BAA4B;EAC5B,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;EAChC,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,6BAA6B;EAC7B,oCAAoC;EACpC,qCAAqC;EACrC,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;EAChC,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;EAChC,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,6BAA6B;EAC7B,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;EAChC,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,6BAA6B;EAC7B,oCAAoC;EACpC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;EAChC,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,6BAA6B;EAC7B,oCAAoC;EACpC,2BAA2B;EAC3B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;AACnC;;AAEA,kGAAkG;;AAElG;EACE,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,yBAAyB;EACzB,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,uCAAuC;EACvC,iDAAiD;AACnD;;AAEA;EACE,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".linhaTitulo {\n  border-bottom: 0.1rem solid #0f2047 !important;\n  margin-left: 40px !important;\n  width: 80px !important;\n  margin-top: -16px !important;\n}\n\n.linhaTituloPopup {\n  border-bottom: 0.2rem solid #0f2047 !important;\n  margin-left: 40px !important;\n  width: 80px !important;\n  margin-top: 0px !important;\n  padding-top: 0px !important;\n}\n\n.tituloContainer {\n  display: flex !important;\n  align-items: center !important;\n  margin-left: 40px !important;\n  margin-top: -28px !important;\n}\n\n.titulo {\n  font-size: 44px !important;\n  color: #0f2047 !important;\n  font-family: \"Abhaya Libre\" !important;\n}\n\n.iconeTitulo {\n  font-size: 40px !important;\n  color: #0f2047 !important;\n  margin-left: 12px !important;\n  margin-right: 12px !important;\n  margin-top: -8px !important;\n}\n\n.iconeTituloPopup {\n  font-size: 40px !important;\n  color: #0f2047 !important;\n  margin-top: -8px !important;\n}\n\n.botaoContainer {\n  display: flex !important;\n  align-items: center !important;\n  margin-left: 40px !important;\n}\n\n.botaoNovo {\n  width: 120px !important;\n  background-color: #0f2047 !important;\n  color: #ffffff !important;\n  border-color: #ffffff !important;\n  border-width: 1px !important;\n  border-style: solid !important;\n  font-family: \"Inter\" !important;\n  font-size: 16px !important;\n  margin-top: 12px !important;\n  margin-left: 20% !important;\n  border-radius: 8px !important;\n  transition: all 0.3s ease !important;\n  text-transform: capitalize !important;\n  height: 36px !important;\n}\n\n.botaoNovo:hover {\n  transform: scale(0.95) !important;\n}\n\n.tituloPopup {\n  font-size: 28px !important;\n  color: #0f2047 !important;\n  font-family: \"Abhaya Libre\" !important;\n  margin: 8px;\n}\n\n.tituloPopupContainer {\n  display: flex !important;\n  align-items: center !important;\n}\n\n.botoesPopupGeral {\n  margin-bottom: 20px !important;\n  margin-right: 20px !important;\n}\n\n.botaoPopupSalvar {\n  width: 180px !important;\n  background-color: #0f2047 !important;\n  color: #ffffff !important;\n  border-color: #ffffff !important;\n  border-width: 1px !important;\n  border-style: solid !important;\n  font-family: \"Inter\" !important;\n  border-radius: 8px !important;\n  transition: all 0.3s ease !important;\n}\n\n.botaoPopupSalvar:hover {\n  transform: scale(0.95) !important;\n}\n\n.botaoPopupCancelar {\n  width: 180px !important;\n  background-color: #ffffff !important;\n  color: #0f2047 !important;\n  border-color: #0f2047 !important;\n  border-width: 1px !important;\n  border-style: solid !important;\n  font-family: \"Inter\" !important;\n  border-radius: 8px !important;\n  transition: all 0.3s ease !important;\n  font-weight: 600 !important;\n}\n\n.botaoPopupCancelar:hover {\n  transform: scale(0.95) !important;\n}\n\n.txtBuscaTabela {\n  margin-top: 16px !important;\n  margin-left: 16px !important;\n}\n\n.iconeBusca {\n  color: #18316e !important;\n  font-size: 28px !important;\n  margin-top: 16px !important;\n}\n\n.textoExclusao {\n  color: #000000 !important;\n  font-family: \"Inter\" !important;\n  font-size: 16px !important;\n}\n\n.tituloExclusao {\n  color: #0f2047 !important;\n  font-family: \"Abhaya Libre\" !important;\n  font-size: 44px !important;\n}\n\n.botaoPopupExcluir {\n  width: 120px !important;\n  background-color: #0f2047 !important;\n  color: #ffffff !important;\n  border-color: #ffffff !important;\n  border-width: 1px !important;\n  border-style: solid !important;\n  font-family: \"Inter\" !important;\n  border-radius: 8px !important;\n  transition: all 0.3s ease !important;\n  margin-right: 7%;\n  margin-bottom: 4%;\n}\n\n.botaoPopupExcluir:hover {\n  transform: scale(0.95) !important;\n}\n\n.botaoPopupCancelarExclusao {\n  width: 120px !important;\n  background-color: #ffffff !important;\n  color: #0f2047 !important;\n  border-color: #0f2047 !important;\n  border-width: 1px !important;\n  border-style: solid !important;\n  font-family: \"Inter\" !important;\n  border-radius: 8px !important;\n  transition: all 0.3s ease !important;\n  font-weight: 600 !important;\n  margin-right: 4%;\n  margin-bottom: 4%;\n}\n\n.botaoPopupCancelarExclusao:hover {\n  transform: scale(0.95) !important;\n}\n\n/* Adicione este trecho de código ao seu arquivo de estilos CSS (por exemplo, styles.module.css) */\n\n.caixaTextoPequena {\n  height: 28px;\n  /* Ajuste a altura conforme necessário */\n}\n\n.caixaDeTexto {\n  margin: 200px 70 !important;\n  height: 30px !important;\n}\n\n.botaoVoltar {\n  background-color: #0f2047;\n  color: #ffffff;\n  border-color: #ffffff;\n  border-width: 1px;\n  border-style: solid;\n  font-family: \"Inter\";\n  border-radius: 8px;\n  transition: all 0.3s ease;\n  text-transform: capitalize;\n  height: 36px;\n}\n\n.botaoVoltar:hover {\n  background-color: #ffffff;\n  color: #0f2047;\n}\n\n.inputPequeno {\n  width: 100%;\n  padding: 5px;\n  box-sizing: border-box;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 14px;\n  /* Adicione mais estilos conforme necessário */\n}\n\n.botaoVoltar:hover {\n  background-color: #0f2047;\n  color: #ffffff;\n}\n\n.labelPequeno {\n  font-size: 12px;\n  /* Ajuste o valor conforme necessário */\n}\n\n.placeholder {\n  font-size: 12px;\n  /* Ajuste o valor conforme necessário */\n  /* Outros estilos do placeholder, se necessário */\n}\n\n.popupHeader {\n  margin-top: 8px;\n  padding-bottom: 0px !important;\n}\n\n.popupContent {\n  padding-top: 0px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"linhaTitulo": `styles_linhaTitulo__Ep5i+`,
	"linhaTituloPopup": `styles_linhaTituloPopup__GMDP0`,
	"tituloContainer": `styles_tituloContainer__Hk87K`,
	"titulo": `styles_titulo__FPngx`,
	"iconeTitulo": `styles_iconeTitulo__89m6G`,
	"iconeTituloPopup": `styles_iconeTituloPopup__bzjw1`,
	"botaoContainer": `styles_botaoContainer__HRwMu`,
	"botaoNovo": `styles_botaoNovo__YUcyj`,
	"tituloPopup": `styles_tituloPopup__tEAnc`,
	"tituloPopupContainer": `styles_tituloPopupContainer__qrOAD`,
	"botoesPopupGeral": `styles_botoesPopupGeral__Di-L+`,
	"botaoPopupSalvar": `styles_botaoPopupSalvar__dgog1`,
	"botaoPopupCancelar": `styles_botaoPopupCancelar__Ag8OR`,
	"txtBuscaTabela": `styles_txtBuscaTabela__avyeN`,
	"iconeBusca": `styles_iconeBusca__9+5LH`,
	"textoExclusao": `styles_textoExclusao__WXc-+`,
	"tituloExclusao": `styles_tituloExclusao__FLb2U`,
	"botaoPopupExcluir": `styles_botaoPopupExcluir__gq-Ks`,
	"botaoPopupCancelarExclusao": `styles_botaoPopupCancelarExclusao__+CTWp`,
	"caixaTextoPequena": `styles_caixaTextoPequena__wun3g`,
	"caixaDeTexto": `styles_caixaDeTexto__DvCZA`,
	"botaoVoltar": `styles_botaoVoltar__MDMkx`,
	"inputPequeno": `styles_inputPequeno__DA4uv`,
	"labelPequeno": `styles_labelPequeno__N98Rd`,
	"placeholder": `styles_placeholder__9meIw`,
	"popupHeader": `styles_popupHeader__zkWxz`,
	"popupContent": `styles_popupContent__Y-XBO`
};
export default ___CSS_LOADER_EXPORT___;
